declare global {
  interface Window {
    toggleSaveButtonState: any
    changeGuard: any
  }
}

type LegacyToggleType = "save" | "saved" | "progress"

// Global method used below is defined in legacy `form.js` -
// toggles button to appropriate states
export const toggleLegacySaveButton = (toggleType: LegacyToggleType) => {
  if (window && window.toggleSaveButtonState && toggleType) {
    // note we pass in `undefined` below because DOM element jQuery uses is
    // defined within legacy `form.js`
    return window.toggleSaveButtonState(undefined, {
      [toggleType]: true
    })
  }
}
